class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	async generateRecommendations(){
	const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
	if ( cartItems.length === 0 ) return;

	const sectionId = this.dataset.section;
	const limit = parseInt(this.dataset.limit) || 6;
	const baseUrl = KROWN.settings.routes.product_recommendations_url;

	// Zbierz ID produktów już w koszyku — żeby ich nie polecać
	const cartProductIds = new Set(
		Array.from(cartItems).map(item => item.dataset.productId)
	);

	// Funkcja pomocnicza: pobierz rekomendacje dla produktu z konkretnym intent
	const fetchRecommendations = async (productId, intent) => {
		try {
		const response = await fetch(
			`${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}&intent=${intent}`
		);
		const text = await response.text();
		const doc = new DOMParser().parseFromString(text, 'text/html');
		const container = doc.querySelector('[data-js-cart-recommendations-performed]');
		if (!container) return [];
		return Array.from(container.querySelectorAll('[data-js-product-item]'));
		} catch(e) {
		return [];
		}
	};

	// Wyciągnij ID produktu z karty rekomendacji
	const getProductIdFromCard = (card) => {
		const link = card.querySelector('a[href*="/products/"]');
		if (!link) return null;
		const match = link.getAttribute('href').match(/pr_rec_pid=(\d+)/);
		return match ? match[1] : null;
	};

	// 1. Zbierz complementary od wszystkich produktów w koszyku
	const complementaryCards = [];
	const seenIds = new Set();

	for (const item of cartItems) {
		const productId = item.dataset.productId;
		const cards = await fetchRecommendations(productId, 'complementary');
		for (const card of cards) {
		const recId = getProductIdFromCard(card);
		// Pomiń jeśli: brak ID, już jest w koszyku, już dodany do listy
		if (!recId || cartProductIds.has(recId) || seenIds.has(recId)) continue;
		seenIds.add(recId);
		complementaryCards.push(card);
		if (complementaryCards.length >= limit) break;
		}
		if (complementaryCards.length >= limit) break;
	}

	// 2. Jeśli za mało — dobierz auto-generated related dla pierwszego produktu
	if (complementaryCards.length < limit) {
		const firstProductId = cartItems[0].dataset.productId;
		const relatedCards = await fetchRecommendations(firstProductId, 'related');
		for (const card of relatedCards) {
		const recId = getProductIdFromCard(card);
		if (!recId || cartProductIds.has(recId) || seenIds.has(recId)) continue;
		seenIds.add(recId);
		complementaryCards.push(card);
		if (complementaryCards.length >= limit) break;
		}
	}

	// 3. Jeśli nic nie mamy — nie renderuj nic
	if (complementaryCards.length === 0) return;

	// 4. Sklej wynik w kontener z HTML pierwszego udanego wywołania
	// (żeby zachować strukturę motywu — nagłówek, slider itd.)
	const firstProductId = cartItems[0].dataset.productId;
	const templateResponse = await fetch(
		`${baseUrl}?section_id=${sectionId}&product_id=${firstProductId}&limit=${limit}&intent=related`
	);
	const templateText = await templateResponse.text();
	const templateDoc = new DOMParser().parseFromString(templateText, 'text/html');
	const templateContainer = templateDoc.querySelector('[data-js-cart-recommendations-performed]');
	
	if (!templateContainer) return;

	// Wyczyść stare karty i wstaw nasze
	const productsContainer = templateContainer.querySelector('.grid') 
		|| templateContainer.querySelector('[data-js-product-item]')?.parentElement;
	
	if (productsContainer) {
		productsContainer.innerHTML = '';
		complementaryCards.forEach(card => productsContainer.appendChild(card));
	}

	this.innerHTML = templateContainer.innerHTML;
	}
}
customElements.define('cart-recommendations', CartRecommendations);